export const removeEmptyStringInObject = (object: {
  [key: string]: string | boolean;
}) => {
  return Object.fromEntries(
    Object.entries(object).filter(([_, value]) => value != '')
  );
};
